module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "blank"
    }
  }, [_c('h2', {
    staticClass: "ui center aligned header"
  }, [_vm._v(_vm._s(_vm.main)), _c('div', {
    staticClass: "sub header"
  }, [_vm._v(_vm._s(_vm.sub))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52186acf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 238
// module chunks = 1